module.exports = __webpack_public_path__ + "img/monitoring-bus-blue.9e3b08d0.svg";